import { countryState } from '@core/country/stores/country.store'
import { periodAPI } from '../services/period.apis'
import { useSetAtom } from 'jotai'
import { useAtomValue } from 'jotai'
import { useTransition } from 'react'
import { periodState } from '../stores/period.store'

export function usePeriod() {
    const [isPending, startTransition] = useTransition()
    const setPeriod = useSetAtom(periodState)
    const country = useAtomValue(countryState)

    const getPeriod = () => {
        startTransition(async () => {
            const response = await periodAPI.getPeriod({ country2alpha: country.shorter, joinPeriod: '' })
            setPeriod(response.data)
        })
    }

    return {
        getPeriod,
        isPending
    }
}
